import { createContext, useContext } from "react"
import { FilesViewContextType } from "../types"

export const FilesViewContext = createContext<FilesViewContextType | null>(null)

export function useFilesView(): FilesViewContextType {
  const context = useContext(FilesViewContext)
  if (!context) {
    throw new Error("useFilesView must be used within a FilesViewProvider")
  }
  return context
}